import Environment from "../../Environment/Environment";
import Translator from "../../Translation/Translator";
import Store from "../../Store/Store";
import RollbarEntity = require('rollbar')

class Rollbar {
  public rollbar: any;

  constructor() {
    this.rollbar = new RollbarEntity({
      accessToken: Environment.get().rollbarApiKey,
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        environment: Environment.get().environment,
        client: {
          javascript: {
            source_map_enabled: true, // true by default

            // -- Add this into your configuration ---
            code_version: Environment.getBuildDate(),
            // ---------------------------------------

            // Optionally have Rollbar guess which frames the error was
            // thrown from when the browser does not provide line
            // and column numbers.
            guess_uncaught_frames: true
          }
        }
      }
    });
  }

  public logError(err, level?) {
    // If the library didn't load yet, return
    if (!this.exists()) {
      return Promise.resolve();
    }

    const errorObject = {...err};

    if (errorObject?.action?.payload) {
      Object.keys(errorObject?.action?.payload || {}).forEach(key => {
        if (key?.toLowerCase().includes("pass")) {
          errorObject.action.payload[key] = "******";
        }
      })
    }

    const userInfo = `user: ${Store.getConfigurator().getState().app?.session?.user?.displayName} [id:${Store.getConfigurator().getState().app?.session?.user?.id}] (${Store.getConfigurator().getState().app?.session?.user?.email}) | agency: ${Store.getConfigurator().getState().app?.session?.user?.agency?.displayName} [id:${Store.getConfigurator().getState().app?.session?.user?.agency?.id}]`;

    const errorMessage = errorObject?.errorId || errorObject?.action ? 
                          `${userInfo}, ${Translator.trans(errorObject?.errorId, {}, "en-US")}, ${JSON.stringify(errorObject?.action)}` : 
                          `${userInfo}`;

    if (typeof level === "string") {
      if (level.toLowerCase() === "warning") {
        return this.rollbar.warning(errorMessage, err);
      }

      if (level.toLowerCase() === "critical") {
        return this.rollbar.critical(errorMessage, err);
      }
    }

    return this.rollbar.error(errorMessage, err);
  }

  public log(message: string, shouldLogToTransport?: boolean, data?: any) {
    // we need to log user actions only on production
    if (!Environment.isProduction()) {
      return;
    }
    
    // If the library didn't load yet, return
    if (!this.exists()) {
      return Promise.resolve();
    }

    if (!shouldLogToTransport) {
      return Promise.resolve();
    }

    if (typeof data === "object" && Object.keys(data || {}).length > 0) {
      Object.keys(data || {}).forEach(key => {
        if (key?.toLowerCase().includes("pass")) {
          data[key] = "******";
        }
      });

      message = `${message}, payload: ${JSON.stringify(data)}`;
    }

    return this.rollbar.info(message);
  }

  public configure(user): void {
    // Configure Rollbar
    if (this.exists()) {
      this.rollbar.configure({
        payload: {
          person: {
            id: user?.id,
            username: user?.displayName,
            email: user?.email,
          }
        }
      });
    }
  }

  public exists(): boolean {
    if (!Environment.isProduction()) {
      return false;
    }

    return typeof this.rollbar !== "undefined";
  }
}

export default new Rollbar();
